/* eslint-disable complexity */
/**
 * iterate - flatten and group through nested data, until un-nested last level
 * unshift first level values and buffer the next level with nesting
 *
 * {0: {1: {2: {...etc}}}} ->
 * {1: {2: {...etc}}} ->
 * {2: {...etc}} ->
 * ... until the end of nesting
 * see tests for examples
 * */
export const convertToPieChart = (nestedData, keyNames) => {
  let dataBuffer = [...nestedData.data];
  const dataSeries = [];

  let level = 0;

  // a pointer to current nesting level
  let cl;

  while (dataBuffer && dataBuffer.length > 0) {
    dataSeries[level] = {};
    // store pointer to an object
    cl = dataSeries[level];

    // save data from an array for nest level
    cl.name = keyNames[level];
    cl.data = dataBuffer.map(({ data: _data, ...rest }) => rest);

    let collectNestedData = [];
    // clone all nested 'data' from objects to a new array
    dataBuffer.forEach((d) => {
      collectNestedData = collectNestedData.concat(d.data);
    });

    dataBuffer = collectNestedData.filter(Boolean);

    level++;
  }

  return { dataSeries };
};

/**
 * collet axis names + data series
 * see tests for examples
 */
export const convertToBarChart = (nestedData, keyNames) => {
  let dataBuffer = [...nestedData.data];
  let cl = [];

  const axis = dataBuffer.map((d) => d.name);

  let level = 0;

  while (dataBuffer && dataBuffer.length > 0) {
    let collectNestedData = [];
    // clone all nested 'data' from objects to a new array
    if (level === 0) {
      collectNestedData = [...dataBuffer];
    } else {
      /**
       * nested could be replaced to just collect names from the data.data array
       * and then use loadsh.uniuqeBy on them rahter than .reduce
       */
      let nested = [];
      dataBuffer.forEach((d) => {
        nested = nested.concat(d.data);
      });
      nested = nested.filter(Boolean);

      // find all unique keys at nested data, to add missing values
      // as 0's are not returned
      const uniqueNames = nested.reduce((names, d) => {
        if (
          (d.name.id && !names.map((n) => n.id).includes(d.name.id)) ||
          (!d.name.id && !names.includes(d.name))
        ) {
          names.push(d.name);
        }

        return names;
      }, []);

      dataBuffer.forEach((d) => {
        if (!d || !d.data) {
          return;
        }

        const dataToAdd = uniqueNames.map((key) => {
          return (
            d.data.find((elem) => {
              return (
                (key.id && elem.name.id === key.id) ||
                (!key.id && elem.name === key)
              );
            }) || {
              name: key,
              // null because there's no value provided
              // we should not set 0 -> see the tests
              value: null,
              data: null,
            }
          );
        });

        collectNestedData = collectNestedData.concat(dataToAdd);
      });
    }

    if (!collectNestedData.filter(Boolean).length) {
      break;
    }

    cl = [];

    const nameObjects = {};

    if (level === 0) {
      cl.push({
        name: keyNames[level],
        data: collectNestedData.map((v) => v.value),
      });
    } else {
      const stacked = collectNestedData
        .filter(Boolean)
        .reduce((dataStackByName, dataElement) => {
          if (dataStackByName[dataElement.name.name]) {
            dataStackByName[dataElement.name.name].push(dataElement.value);
          } else {
            dataStackByName[dataElement.name.name] = [dataElement.value];
            nameObjects[dataElement.name.name] = dataElement.name;
          }

          return dataStackByName;
        }, {});
      const series = [];
      Object.keys(stacked).forEach((key) => {
        series.push({
          stack: keyNames[level],
          name: nameObjects[key],
          data: stacked[key],
        });
      });

      cl.push(...series);
    }

    dataBuffer = collectNestedData.filter(Boolean);

    level++;
  }

  return {
    axis,
    dataSeries: cl,
  };
};
